/**
 * Settings API - user profile and preferences
 */
import { apiClient } from './client'
import type {
  UserProfile,
  UserProfileUpdate,
  UserPreferences,
  UserPreferencesUpdate,
} from '../types'

const BASE_PATH = '/api/settings'

export const settingsApi = {
  // Profile
  getProfile: async (): Promise<UserProfile> => {
    const response = await apiClient.get<UserProfile>(`${BASE_PATH}/profile`)
    return response.data
  },

  updateProfile: async (data: UserProfileUpdate): Promise<UserProfile> => {
    const response = await apiClient.put<UserProfile>(`${BASE_PATH}/profile`, data)
    return response.data
  },

  // Preferences
  getPreferences: async (): Promise<UserPreferences> => {
    const response = await apiClient.get<UserPreferences>(`${BASE_PATH}/preferences`)
    return response.data
  },

  updatePreferences: async (data: UserPreferencesUpdate): Promise<UserPreferences> => {
    const response = await apiClient.put<UserPreferences>(`${BASE_PATH}/preferences`, data)
    return response.data
  },

  // Onboarding
  getOnboardingStatus: async (): Promise<{ enrolled_at: string | null }> => {
    const response = await apiClient.get<{ enrolled_at: string | null }>(`${BASE_PATH}/onboarding`)
    return response.data
  },

  enrollOnboarding: async (): Promise<void> => {
    await apiClient.post(`${BASE_PATH}/onboarding/enroll`)
  },

  resetOnboarding: async (): Promise<void> => {
    await apiClient.delete(`${BASE_PATH}/onboarding`)
  },
}
